"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.monitorMeta = exports.createInspectFetchJson = void 0;
const fetch_json_1 = require("@volkswagen-onehub/fetch-json");
async function formatErrorResponse(response) {
    const text = await response.text();
    try {
        return JSON.stringify(JSON.parse(text), null, 2);
    }
    catch (error) {
        return text;
    }
}
function createInspectFetchJson(config) {
    const { logger = console } = config;
    const fetchResponse = (0, fetch_json_1.createFetchResponse)(config);
    const cacheMonitoring = [];
    async function fetchJson(serviceConfig, serviceName, options = {}) {
        const response = await fetchResponse(serviceConfig, serviceName, options);
        if (!response) {
            return;
        }
        try {
            if (!response.ok) {
                logger.error('Error while fetching data:', response.url, response.status, response.statusText);
                logger.error(await formatErrorResponse(response));
                return;
            }
            const data = await response.json();
            monitorMeta(data, serviceName, serviceConfig, options, cacheMonitoring);
            return data;
        }
        catch (error) {
            logger.error('Error while parsing fetched data:', response.url, response.status, response.statusText, error);
            return;
        }
    }
    fetchJson.initialize = (mockConfig) => {
        fetchResponse.initialize(mockConfig);
    };
    fetchJson.getMetrics = fetchResponse.getMetrics;
    fetchJson.getCacheMonitoring = () => cacheMonitoring;
    return fetchJson;
}
exports.createInspectFetchJson = createInspectFetchJson;
function monitorMeta(data, serviceName, serviceConfig, options, cacheMonitoring) {
    if (assertDataWithMeta(data) && assertMeta(data.meta)) {
        const meta = data.meta;
        cacheMonitoring.push({
            name: serviceName,
            url: serviceConfig.origin +
                (serviceConfig.path || '') +
                (options.searchParams ? '?' + options.searchParams.toString() : ''),
            status: meta,
        });
    }
}
exports.monitorMeta = monitorMeta;
function assertProp(target, prop, type, required) {
    if (typeof target == 'object' && target) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const exists = prop in target && typeof target[prop] === type;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return exists && (!required || target[prop]);
    }
    return false;
}
function assertMeta(meta) {
    return (assertProp(meta, 'date', 'string', true) &&
        assertProp(meta, 'hash', 'string'));
}
function assertDataWithMeta(data) {
    return assertProp(data, 'meta', 'object');
}
//# sourceMappingURL=createInspectFetchJson.js.map